import React,{PureComponent,Fragment} from 'react';
import {Tabs,Badge,  Tooltip,  } from 'antd';
import PageCommon from  "@components/PageCommon/PageCommon";
import { Link } from "react-router-dom"
import {postDeliveryList, postDeliveryListInfo, postBatchDelivery,downloadDeliverOrder} from '@/api/warehouseManagement/outWarehouse';
import IconVerified from "@components/Icon/IconVerified";
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import VipLvLevel from "@components/Icon/vip-badge/vipLvLevel";
import { toFixedWithCommas} from "@utils/number-util";
import {isEmpty,trim, toFixed2,formatNumberToPrice,symbolMoneyUtil,getWeek,getIntlYYMMDD} from '@utils/utils';
import CustomerEmailStatus from "@components/customerEmailStatus/customerEmailStatus";
import eventProxy from '@/utils/eventProxy';
import Lang from "@/components/Lang/Lang";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import CustomerList from './components/List';
import NewBuyerLabelAndHistoryDrawer from "@components/StatuLabel/NewBuyerLabelAndHistoryDrawer"
import AllocationFollowUserBtn from "./components/AllocationFollowUserBtn"
import Cookie from "../../../utils/cookie";
import './CustomerIndex.less' ;
import FollowAction from "../Follow/Follow.action";

class CustomerIndex extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            loading:false,
            waitIntoNum: "",
            tabKay: '-20',
            // 表单 配置
            searchFormOptions:[
                {
                    name:'foreignUserId',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请选择跟进人',
                    cnPlaceholderId:'QingXuanZeGenJinRen',
                    width:180,
                    type:"SearchSelect",
                    searchClass:{
                        api:"/service/mg/follower/search/foreign",
                    },
                },
                {
                    name:'contactWay',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'搜索客户名称/编号/联系电话/邮箱',
                    cnPlaceholderId:'SouSuoKeHuMingChengBianHa2',
                    width:355,
                },
            ],
            columns:[
                {
                    // cnTitle: '客户信息',
                    // cnTitleId: 'KeHuLieBiao',
                    title: Lang({id: "KeHuLieBiao", default: "客户信息"}),
                    dataIndex: 'buyerCode',
                    width: 180,
                    render:(text, item, index) => (<Tooltip placement="bottomLeft"
                                                           zIndex={9}
                                                           title={<div className={"black89 intoBox"}>
                                                               <div className={"mb_4 flex-item-ver-center"}>{Lang({id:"DianZiYouXiangYongHuZhang",default:"电子邮箱/用户账号"})}<span className={"ml_16 black66 mr_16"}>{item.email||-""}</span>
                                                                       <CustomerEmailStatus verifyEmailStatus={item.verifyEmailStatus+""} />
                                                               </div>
                                                               <div className={"mb_4"}>{Lang({id:"ShouJi",default:"手机"})}<span className={"ml_16 black66"}>{item.telCode?<span className={"mr_4"}>+{item.telCode}</span>:""} {item.mobile||"--"}</span></div>
                                                               <div className={"mb_4"}>{Lang({id:"GongSiLeiXing",default:"公司类型"})}<span className={"ml_16 black66"}>{item.companyType||"--"}</span></div>
                                                               <div className={"flex-item"}>{Lang({id:"JingYingLeiMu",default:"经营类目"})}<span className={"ml_16 black66 flex-1"}>{item.mainCategoryName||"--"}</span></div>
                                                               <div className={"mb_4 flex-item"}>{Lang({id:"GenJinJiLu",default:"跟进记录"})}<div className={"ml_16 black66 flex-1"}>
                                                                   {
                                                                       !isEmpty(item.lastFollowDays)?<div className={"flex-item flex-item-ver-center"}>
                                                                           {/* {0} 天前跟进过 今天跟进过*/}
                                                                           <span>{item.lastFollowDays>0?Lang({id:"NTianQianGenJinGuo",default:`${item.lastFollowDays} 天前跟进过`,params:[item.lastFollowDays]}):Lang({id:"JinTianGenJinGuo",default:"今天跟进过"})}</span>
                                                                           {/* 下次跟进 4月22日 周一 (5天后) | 下次跟进 {0}*/}
                                                                           {item.nextFollowDays>=0&&item.nextFollowTime&&item.nextFollowTime>0?<Fragment>，
                                                                               <span className={"mr_8"} dangerouslySetInnerHTML={{__html: __getServerLanguage('XiaCiGenJinN', `${getIntlYYMMDD(item.nextFollowTime)+" "+getWeek(item.nextFollowTime)}（<span class="${item.nextFollowDays<0?'text-red':''}">${item.nextFollowDays===0?__getServerLanguage('JinTian'):__getServerLanguage('NTianHou',item.nextFollowDays)}</span>`)+"）。"}}>
                                                                </span>
                                                                           </Fragment>:null}
                                                                       </div>:"--"
                                                                   }
                                                               </div></div>
                                                           </div>}
                                                           arrow={false}
                                                           color={"#fff"}
                        // trigger={"click"}
                                                           overlayClassName={"customerTooltips"}>
                        <div className={"hoverBox"}>
                            <div className={"flex-item-ver-center"}>
                                <Link target={"_blank"}
                                    className="color-blue3 fw_700 font-16"
                                    to={`/customer/detail?id=${item.id}`} >
                                    {item.buyerCode||'-'}
                                </Link>
                                {(!isEmpty(item.isTargetCustomer)||item.pointLevel&&item.pointLevel>0)?<span className={"spanLevel ml_4"}>
                                    {!isEmpty(item.isTargetCustomer)?<IconVerified isTargetCustomer={item.isTargetCustomer} />:null}
                                    {item.pointLevel&&item.pointLevel>0?<VipLvLevel grade={item.pointLevel} width={24} />:null}
                                </span>:null}
                                {item.isKaBuyer=="1"?<span className={"ml_4 kaLabel"}>KA</span>:null}
                            </div>
                            {item.name?<div className="fw_500">{item.name}</div>:null}
                            {item.city?<div className="black45">{item.city}</div>:null}
                       </div>
                    </Tooltip>),
                },
                {
                    // cnTitle: '最近下单',
                    // cnTitleId: 'ZuiJinXiaDan',
                    title: Lang({id: "ZuiJinXiaDan", default: "最近下单"}),
                    dataIndex: 'poCode',
                    width: 200,
                    render:(poCode, row, index) => (<>
                        {poCode?<div className={"black89"}>{poCode}</div>:null}
                        <div className={"mb_4"}>{row.lastOrderTime?getIntlYYMMDD(row.lastOrderTime,"HH:mm"):"-"}</div>
                    </>)
                },
                {
                    // cnTitle: '最近访问',
                    // cnTitleId: 'ZuiJinFangWen',
                    title: Lang({id: "ZuiJinFangWen", default: "最近访问"}),
                    dataIndex: 'lastVisitTime',
                    render:(text, row, index) => ( <span>{row.lastVisitTime&&getIntlYYMMDD(row.lastVisitTime,"HH:mm")}</span>)
                },
                {
                    // cnTitle: '阶段',
                    // cnTitleId: 'JieDuan',
                    title: Lang({id: "JieDuan", default: "阶段"}),
                    dataIndex: 'buyerLabelType',
                    width: 300,
                    render:(buyerLabelType, row, index) => {
                        // const iMillis =  row.remainderFollowTime || 0;
                        // const iHour =  Math.ceil(iMillis/1000/60/60);
                        // const iDay = Math.ceil(iHour/24);
                        return (<>
                            <div>
                                <NewBuyerLabelAndHistoryDrawer statusCode={buyerLabelType} key={row.id+"_s"+index}
                                                               status={row.buyerLabelTypeName}
                                                               buyerId={row.id}
                                                               reRefreshSearch={()=>{
                                                                   this.getStatistics();
                                                                   this.onPageListChild.reRefreshSearch(false);
                                                               }}
                                                               labelType={"1020"}//1010:新客标签 1020:成交客户标签
                                />
                                <AllocationFollowUserBtn buyerId={row.id}
                                                         reRefreshSearch={()=>this.onPageListChild.reRefreshSearch(false)}
                                                         foreignUserId={row.foreignUserId}
                                                         key={row.id+"_b"+index}
                                                         foreignUserName={row.foreignUserName}  />
                            </div>
                        </>)
                    }
                },
            ],
            tabOptions:[//成交客户类型 -20全部(110.新客 120.成长客户 130.留存客户 140.预流失客户 150.已流失客户)
                {
                    key:'-20',
                    name:Lang({id:"QuanBu", default:"全部"}),
                    // count:'allBuyerTotal',
                },
                {
                    key:'110',
                    name:Lang({id:"XinKe", default:"新客"}),
                    count:'newBuyerTotal',
                },
                {
                    key:'120',
                    name:Lang({id:"ChengZhangKeHu", default:"成长客户"}),
                    count:'growingBuyerTotal',
                },
                {
                    key:'130',
                    name:Lang({id:"LiuCunKeHu", default:"留存客户"}),
                    count:'retainBuyerTotal',
                },
                {
                    key:'140',
                    name:Lang({id:"YuLiuShiKeHu", default:"预流失客户"}),
                    count:'preLossBuyerTotal',
                },
                {
                    key:'150',
                    name:Lang({id:"YiLiuShiKeHu", default:"已流失客户"}),
                    count:'lossBuyerTotal',
                },
            ]
        }
    }
    tabsOnChange(key) {
        this.setState({
            tabKay: key,
        },() => {
            this.onPageListChild.reRefreshSearch();
        })
    }
    // 查询回调
    fetchCallBack(res){
        // const {success,valid,model,paging} = res;
    }
    onRefListOne = (ref) =>  this.onPageListChild = ref;
    componentDidMount() {
        eventProxy.on('redirectPage', (path) => { //不知道为啥，旧代码有此逻辑，先加上
            this.props.history.replace(path)
        })
        const optionExtra  = Cookie.getJSON("fmg.extra") || {};
        this.setState(
            {
                optionExtra: optionExtra,
                fxUserId: optionExtra.fxUserId
            },
            () => {
            }
        );
    }
    searchReset(){
        this.setState({
            abnormalTakeTimeSort:''
        },()=>this.onRefAutoFetchListChrld.handleFetch(1,false))
    }
    /**
     * 客户列表统计
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8298
     */
    getStatistics() {
        FollowAction.postAction("/service/mg/follower/list/statistics",{
            tapType: -20,//tap页类型 -10:新客列表 20:成交客户列表
        }).then(res=>this.geStatisticsRes(res.data)).catch(err=>this.geStatisticsRes(err));
    }
    geStatisticsRes(res){
        const {success,valid,model,} = res;
        if (success && valid) {
            this.setState({
                tabsNums:model||{}
            })
        }
    }
    componentWillMount() {
        this.getStatistics()
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const {loading, columns=[],searchFormOptions, tabsNums={}, tabKay, fxUserId, tabOptions=[]} = this.state;
        return (<PageCommon onRef={this.onRefPageCommon}
                        loading={loading}>
                <CommonBreadcrumb list={[
                    {name:Lang({id:"YiChengJiaoKeHu", default:"已成交客户"})},
                ]}></CommonBreadcrumb>
                <div className={"customerList"}>
                    <Tabs activeKey={tabKay}onChange={this.tabsOnChange.bind(this)}
                        items={
                            tabOptions.map(opt=>{return {
                                key: opt.key,
                                label:( <div className={"flex-item"}>
                                    {opt.name}
                                    {opt.count?<Badge count={tabsNums[opt.count]||0}/>:null}
                                </div>),
                            }} ) }
                    >
                    </Tabs>
                    <CustomerList onRef={this.onRefListOne}
                                   searchFormOptions={searchFormOptions}
                                   precondition={{
                                       tapType: tabKay,
                                   }}
                                  labelType={"1020"}//1010:新客标签 1020:成交客户标签
                                  fetchCallBack={(data)=>this.fetchCallBack(data)}
                                  fxUserId={fxUserId}
                                  tabKay={tabKay}
                                  allTabs={tabKay=="-20"}
                                  columns={columns}  />
                </div>
            </PageCommon>
        )
    }
}

export default CustomerIndex
